
export const DEVICE_CHANGED_PC = "DEVICE_CHANGED_PC"

export const DEVICE_CHANGED_TB = "DEVICE_CHANGED_TB"

export const DEVICE_CHANGED_SP = "DEVICE_CHANGED_SP"

